import { render } from "./ShippingDeliveries.vue?vue&type=template&id=6358f942"
import script from "./ShippingDeliveries.vue?vue&type=script&lang=js"
export * from "./ShippingDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__